<template>
  <v-dialog v-model="visible" scrollable persistent max-width="700" @keydown.esc="cancelForm()">
    <v-card>
      <v-card-title class="title">
        {{ title }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-subtitle><small>(*) indica campos requeridos</small></v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="ubicacionForm" v-model="validations.isValid">
          <v-container class="px-0" fluid>
            <v-row>
              <v-col>
                <v-row>
                  <v-col>
                    <v-text-field
                  v-model="fields.pedido"
                  :rules="validations.pedido"
                  :error-messages="errors.pedido"
                  :disabled="loading || !isNewRecord"
                  label="No pedido*"
                  required
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="fields.proveedor"
                  :rules="validations.proveedor"
                  :error-messages="errors.proveedor"
                  :disabled="loading || !isNewRecord"
                  label="Proveedor*"
                  required
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="fields.bastidor"
                  :disabled="loading || !isNewRecord"
                  label="No Bastidor*"
                  required
                  outlined
                ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                  v-model="fields.marca"
                  :rules="validations.marca"
                  :error-messages="errors.marca"
                  :disabled="loading || !isNewRecord"
                  label="Marca*"
                  required
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="fields.modelo"
                  :rules="validations.modelo"
                  :error-messages="errors.modelo"
                  :disabled="loading || !isNewRecord"
                  label="Modelo*"
                  required
                  outlined
                ></v-text-field>
                <custom-date-picker
                  v-model="fields.fecha"
                  label="Fecha de pedido*"
                  :rules="validations.fecha"
                  :error-messages="errors.fecha"
                  outlined
                  required
                ></custom-date-picker>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="loading" @click="cancelForm()" class="grey--text" light text>Cancelar</v-btn>
        <v-btn :loading="loading" :disabled="saveIsDisabled" @click="saveForm()" color="primary" text>Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import _ from 'lodash'
import CustomDatePicker from '../../components/CustomDatePicker.vue'

export default {
  props: {
    value: null
  },
  components: {
    CustomDatePicker
  },

  data: () => ({
    visible: true,
    loading: false,
    visibleAsignacionForm: false,

    // campos del formulario
    user: null,

    fields: {
      pedido: null,
      proveedor: null,
      marca: null,
      modelo: null,
      fecha: null
    },

    // lista de usuarios (tabla Trabajador)
    userState: {
      list: [],
      search: null,
      loading: false
    },

    // validaciones
    validations: {
      isValid: true,
      pedido: [
        (v) => !!v || 'Debe proporcionar numero de pedido.'
      ],
      proveedor: [
        (v) => !!v || 'Debe proporcionar un proveedor.'
      ],
      fecha: [
        (v) => !!v || 'Debe proporcionar una fecha.'
      ],
      marca: [
        (v) => !!v || 'Debe proporcionar una marca del vehiculo.'
      ],
      modelo: [
        (v) => !!v || 'Debe proporcionar una modelo del vehiculo.'
      ]
    },

    // errores
    errors: {
      pedido: [],
      proveedor: [],
      fecha: [],
      marca: [],
      modelo: []
    }
  }),

  async created () {
    if (this.value) {
      this.loading = true
      await this.$store.dispatch('VIEW_USER', { ...this.value, expand: 'asignacion_list' }).then(result => {
        this.user = Object.assign({}, this.value)
        this.userState.list.push(this.user)
        this.fields = Object.assign({}, result)
        this.loading = false
      })
    }
  },

  methods: {
    saveForm () {

      /* this.$refs.userForm.validate()
      if (this.validations.isValid) {
        this.loading = true

        let user = Object.assign({}, this.user, this.fields)
        this.$store.dispatch(this.isNewRecord ? 'ADD_USER' : 'UPDATE_USER', user).then(response => {
          let { error, data, status } = response
          if (error) {
            if (status === 422) {
              // mostrando los errores de validación en los campos correspondientes
              data.forEach(({ field, message }) => {
                if (this.errors[field]) {
                  this.errors[field].push(message)
                }
              })
            } else {
              // mostrando cualquier otro error al usuario en una notificación
              this.$toast.error('Ocurrió un error al intentar registrar o actualizar la cuenta de usuario')
            }
          } else {
            this.$emit('save', { insert: this.isNewRecord, value: data })
          }
          this.loading = false
        })
      } */
    },
    cancelForm () {
      this.$emit('cancel')
    }
  },

  computed: {
    isNewRecord () {
      return !this.value
    },
    title () {
      return this.isNewRecord ? 'Nuevo pedido' : 'Modificar pedido'
    },
    saveIsDisabled () {
      return this.loading || this.pedido || this.proveedor || this.fecha || this.marca || this.modelo
    },
    searchTerm () {
      return this.userState.search
    }
  },

  watch: {
    searchTerm (val) {
      val && this.userDebouncedSearch()
    }
  }
}
</script>
